import { render } from "./Pamphlet-L.vue?vue&type=template&id=aa620710&scoped=true"
import script from "./Pamphlet-L.vue?vue&type=script&lang=js"
export * from "./Pamphlet-L.vue?vue&type=script&lang=js"

import "./Pamphlet-L.vue?vue&type=style&index=0&id=aa620710&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa620710"]])

export default __exports__